<!--
 * @Author: xuesong
 * @Date: 2021-04-19 10:51:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 11:52:31
 * @Description: 会诊-病历卡片
-->
<template>
  <div class="custom-synine">
    <div class="info-content">
      <span class="text-icon"></span>
      <div class="top">
        <span class="text-title">{{ data.sentTime }} {{ data.text }}</span>
        <span class="text-sign">请查阅您的诊疗小结</span>
      </div>
    </div>
    <div class="bot" @click="detailClick">
      <span>立即查阅</span>
      <i class="el-icon-arrow-right"></i>
    </div>
    <el-dialog :title="title" append-to-body :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <div class="content">
        <label>小结内容:</label>
        <p class="con-height" v-html="synergyConclusion"></p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSynergyConclusionDetail } from "../../api/crossApi";
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      title: "",
      synergyConclusion: ""
    };
  },
  methods: {
    async detailClick() {
      this.dialogVisible = true;
      let { code, data } = await getSynergyConclusionDetail({
        synergyId: this.data.synergyId
      });
      if (code === 0) {
        this.title = data.title;
        this.synergyConclusion = data.synergyConclusion;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="less">
.custom-synine {
  .el-dialog {
    .content {
      display: flex; 
      label {
        width: 80px;
      }
      p {
        flex: 1; 
      }
    }
  }
}
</style>

<style scoped lang="less">
.custom-synine {
  width: 350px;
  border-radius: 6px;
  background: linear-gradient(180deg, #fffbf0 0%, #ffffff 100%);
  box-shadow: 0px 4px 8px 0px rgba(204, 204, 204, 0.2);
  padding: 12px;
  cursor: pointer;
  .bot {
    text-align: right;
    margin-top: 8px;
    border-top: 1px solid #f8f3ea;
    padding-top: 13px;
    color: #333333;
    i {
      margin-left: 8px;
    }
  }
  .info-content {
    font-size: 12px;
    font-weight: 500;
    display: flex;
    .text-icon {
      display: flex;
      width: 32px;
      height: 32px;
      background: url(../../static/IMInput/text_icon.png) no-repeat;
      background-size: contain;
      margin-right: 8px;
    }
    .top {
      display: flex;
      flex-direction: column;
      text-align: left;
      .text-title {
        font-size: 12px;
        color: #333333;
        font-weight: 500;
        line-height: 22px;
      }
      .text-sign {
        font-size: 12px;
        color: #666666;
        margin-top: 4px;
      }
    }
  }
}
</style>